export default [
	{ value: "en", name: "English" }, // MUST BE FIRST
	{ value: "esp", name: "Español" },
	{ value: "fr", name: "Français" },
];
